import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=5a787715&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a787715')) {
      api.createRecord('5a787715', component.options)
    } else {
      api.reload('5a787715', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=5a787715&", function () {
      api.rerender('5a787715', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yR9JkEhu7ocM/JS/comp/ImgFallback.vue"
export default component.exports